

















import Vue, { PropType } from "vue"
import PSimilarUserProfileCassetteList from "./local/PSimilarUserProfileCassetteList.vue"
import PPlainDetail from "./local/PPlainDetail.vue"
import Container from "~/components/guideline/frame/Container.vue"
import {
  similarUserProfilesGetter,
  SimilarUserProfile,
} from "~/uiLogics/similarUserProfilesGetter"
import { UserProfileSearchResultView } from "~/backendApis/viewModel"
import CInquirySignUpFloatingButtonGroup from "~/components/custom/buttonGroup/CInquirySignUpFloatingButtonGroup.vue"

interface DataType {
  similarUserProfiles: SimilarUserProfile[]
}

export default Vue.extend({
  components: {
    Container,
    PPlainDetail,
    PSimilarUserProfileCassetteList,
    CInquirySignUpFloatingButtonGroup,
  },
  props: {
    /**
     * 表示するプロフィール
     */
    userProfile: {
      type: Object as PropType<UserProfileSearchResultView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      similarUserProfiles: [],
    }
  },
  created() {
    this.initializeSimilarUserProfiles()
  },
  methods: {
    async initializeSimilarUserProfiles() {
      if (this.userProfile.mainSmallJobCategoryId) {
        const excludedUniversalUids = [this.userProfile.universalUid]
        this.similarUserProfiles = await similarUserProfilesGetter().getByLargeJobCategoryId(
          this.userProfile.mainSmallJobCategoryId,
          excludedUniversalUids
        )
      }
    },
  },
})
